import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

export default class TeamCarousel {
    constructor() {
        // Scope each instance to its own wrapper (element refs, not global
        // selectors) so its nav buttons only drive its own carousel.
        document.querySelectorAll('.js-team-carousel').forEach((root) => {
            const el = root.querySelector('.js-team-carousel__swiper');

            if (!el) return;

            new Swiper(el, {
                a11y: true,
                autoHeight: true,
                modules: [A11y, Navigation],
                navigation: {
                    nextEl: root.querySelector('.js-team-carousel__nav.is-next'),
                    prevEl: root.querySelector('.js-team-carousel__nav.is-prev'),
                    disabledClass: 'is-disabled',
                },
                slidesPerGroup: 1,
                slidesPerView: 1,
                spaceBetween: 0,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                },
            });
        });
    }
}
